import { useState } from "react";
import Data from "../../data/certificates.json";

import CertificateCard from "./components/CertificateCard";

function Certificates() {
  const [active, setActive] = useState(Data[0]);

  return (
    <div className="my-3 container text-center">
      <div className="section-title">
      <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>Unlock your Full Stack Developer</b><b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}> Certification!</b></h2><br/>
       <p className="text-center mt-3 mb-5">
          Elevate your career with our esteemed certification. Unlock new opportunities and demonstrate your mastery in Full Stack Development.
        </p>
      </div>
      <div className="d-flex justify-content-between justify-content-md-start text-left my-5 tabs">
        {
        Data.map(item => <button className={`btn ${active.id === item.id ? "active" : ""}`} onClick={() => setActive(item)}><h3 style={{ fontSize: '13px' }}>{item.label}</h3></button>)
        }  
      </div>
      <CertificateCard {...active} />
    </div>
  );
}
export default Certificates;
